'use client'

import { StepperTiers } from 'fukku/StepperTiers'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import {
	DEFAULT_NET_ANUAL_EXPENSE,
	PROGRESS_BAR_LABEL,
} from '../../constants/statusModule'

type StepperTiersProps = {
	readonly className?: string
	readonly annualNetExpense: number | undefined
	readonly progressBarMax: number | undefined
	readonly progressBarSteps:
		| {
				threshold: number
				text: string
		  }[]
		| undefined
	readonly totalLikes: number | undefined
}

export const StepperTiersModule = ({
	className,
	annualNetExpense,
	progressBarMax,
	progressBarSteps,
	totalLikes,
}: StepperTiersProps) => {
	const { t } = useLabels()

	const shouldRender =
		!!progressBarSteps && !!progressBarMax && totalLikes !== undefined

	return (
		shouldRender && (
			<div className={className}>
				<StepperTiers
					max={progressBarMax}
					value={annualNetExpense ?? DEFAULT_NET_ANUAL_EXPENSE}
					steps={progressBarSteps}
					label={t(PROGRESS_BAR_LABEL)}
				/>
			</div>
		)
	)
}
